export const  getLast24MonthsDates = ()  =>{
  const currentDate = new Date();
  const monthDates = [];

  for (let i = 0; i < 24; i++) {
    // Calculate the last day of each of the last 24 months
    // Use month + 1 and day 0 to get the last day of the current month
   const date = new Date(Date.UTC(currentDate.getFullYear(), currentDate.getMonth() - i + 1, 0));
const formattedDate = date.toISOString().split('T')[0]; 


    monthDates.push(formattedDate);
  }

  console.log(monthDates)

  return monthDates;
}


